import Dexie from 'dexie';

const DB_NAME = 'kiosk-metadata';

const db = new Dexie(DB_NAME);
db.version(1).stores({
  products: 'id, *productGroupIds',
});

export default db;